import React, { useState, FormEvent, useEffect } from "react";
import "./AdditionalInfo.css";
import { useDispatch, useSelector } from "react-redux";
import { GetReview, postReview } from "../../../Action/buy.Actions";
import { AppDispatch } from "../../../App/store";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";


interface AdditionalInfoProps {
  itemdescription: string;
  itemid: number
  memberid: number;
}


const AdditionalInfo: React.FC<AdditionalInfoProps> = ({ itemdescription, itemid, memberid }) => {
  const [activeTab, setActiveTab] = useState<"aiTab1" | "aiTab2" | "aiTab3">("aiTab1");

  const { successgetReview, successReview } = useSelector((state: any) => state.BuyOrder)
  const navigate = useNavigate()

  const dispatch = useDispatch<AppDispatch>()

  const handleTabClick = (tab: "aiTab1" | "aiTab2" | "aiTab3") => {
    setActiveTab(tab);
  };

  const [reviewDescription, setReviewDescription] = useState("");
  const scrollToTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault();

    const payload = {
      memberid,
      itemid,
      reviewdescription: reviewDescription,
    };

    const datavalue = await dispatch(postReview(payload));

    if (memberid) {
      if (datavalue) {
        toast.success('SuccessFully  Review submitted')
        await dispatch(GetReview(itemid))
      }
      else {
        toast.error('Review is not submitted')
      }
      setReviewDescription("");
    }
    else {
      toast.error('Please login to add item review')
      scrollToTop()
      navigate('/loginSignUp')

    }
    // Clear the form
  };


  return (
    <div className="productAdditionalInfo">
      <div className="productAdditonalInfoContainer">
        <div className="productAdditionalInfoTabs">
          <div className="aiTabs">
            <p
              onClick={() => handleTabClick("aiTab1")}
              className={activeTab === "aiTab1" ? "aiActive" : ""}
            >
              Description
            </p>
            <p
              onClick={() => handleTabClick("aiTab2")}
              className={activeTab === "aiTab2" ? "aiActive" : ""}
            >
              Write a Review
            </p>
            <p
              onClick={() => handleTabClick("aiTab3")}
              className={activeTab === "aiTab3" ? "aiActive" : ""}
            >
              Reviews ({Array.isArray(successgetReview) ? successgetReview.length : 0})
            </p>
          </div>
        </div>

        <div className="productAdditionalInfoContent">
          {activeTab === "aiTab1" && (
            <div className="aiTabDescription">
              <div className="descriptionPara">

                <p>
                  {itemdescription}
                </p>
              </div>
            </div>
          )}

          {activeTab === "aiTab2" && (
            <div className="aiTabAdditionalInfo">
              <h3>Submit Your Review</h3>



              <div className="userNewReviewForm">
                <form onSubmit={handleSubmit}>
                  <textarea
                    cols={30}
                    rows={8}
                    placeholder="Your Review"
                    required
                    value={reviewDescription}
                    onChange={(e) => setReviewDescription(e.target.value)}
                  />

                  <div className="userNewReviewFormCheck">
                    <label>
                      <input type="checkbox" />
                      Save my review for future
                    </label>
                  </div>

                  <button type="submit">Submit</button>
                </form>
              </div>
            </div>
          )}

          {activeTab === "aiTab3" && (
            <div className="aiTabReview">
              <div className="aiTabReviewContainer">
                <h3>Reviews</h3>

                {/* Review 1 */}
                <div className="userReviews">
                  <div className="userReview" style={{ borderBottom: "1px solid #e4e4e4" }}>
                    <div className="userReviewImg">
                    </div>
                    <div className="userReviewContent">

                      <div className="userReviewBottomContent" style={{ marginBottom: "30px" }}>
                        {
                          Array.isArray(successgetReview) &&
                          successgetReview.map((item: any, index: number) => (
                            <p key={item?.id}>
                              <span>{index + 1}</span> {item?.Reviewdescription}
                            </p>
                          ))
                        }

                      </div>
                    </div>
                  </div>

                  {/* Review 2 */}

                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdditionalInfo;
